import axios from "axios";
import { apiUrl } from "../constant";

export const getAllPendingUsersService = (data) => {
    return axios.post(`${apiUrl}/api/get_all_pending_signup`, data);
};

export const resetUserPasswordToDefaultService = (data) => {
    return axios.post(`${apiUrl}/ResetPasswordToDefault`, data);
};

export default {
    getAllPendingUsersService,
    resetUserPasswordToDefaultService,
};